const passwordlessHttpCode = {
  notSendRequest: 0,
  success: 200,
  //otp token exception
  otp_token_login_too_many_attempts: 40302,
  //customer exception
  customer_blocked: 40304,
  blocked: 40311,
  max_try_count: 40312,

  customer_not_found: 404114,
  customer_recipient_address_not_found: 404123,
  customer_exists: 59280,
  //configuration exception
  webHook_error: 40940,
  script_error: 40930,
  journey_auth_config_conflict: 40906,
  journey_auth_config_missing: 404119,
  journey_steps_config_missing: 404104,
  global_error: 500,
};

const tokenHttpCode = {
  notSendRequest: 0,
  success: 200,
  //params send exception
  otp_message_code_missing: 40002,
  otp_token_missing: 400113,
  personal_id_missing: 400115,
  //customer exception
  customer_too_many_attempts: 40304,
  //only when grantType is AuthCode
  customer_not_found: 404114,
  //otp token exception
  otp_token_invalid: 40303,
  otp_token_expired: 40306,
  //otp message code exception
  otp_message_code_max_retry_for_otp_token: 40301,
  otp_no_recipient_address: 404123,
  otp_message_code_invalid_for_otp_token: 40305,
  //configuration exception
  journey_auth_config_conflict: 40906
}

const rescheduleHttpCode = {
  general_error: 40313,
  invalid_process_data_conflict: 40953,
  process_status_must_be_expected_conflict: 40951,
  appointment_time_error_conflict: 40952
}

const handleHttpCode = {
  webHook_Error: passwordlessHttpCode.webHook_error,
  script_error: passwordlessHttpCode.script_error,
  notSendRequest: passwordlessHttpCode.notSendRequest,
  success: passwordlessHttpCode.success,
  customer_blocked: passwordlessHttpCode.customer_blocked,
  customer_too_many_attempts: passwordlessHttpCode.otp_token_login_too_many_attempts,
  customer_already_exists: passwordlessHttpCode.customer_exists,
  customer_not_found: passwordlessHttpCode.customer_not_found,
  customer_recipient_address_not_found: passwordlessHttpCode.customer_recipient_address_not_found,
  global_error: passwordlessHttpCode.global_error,
  journey_auth_config_missing: passwordlessHttpCode.journey_auth_config_missing,
  max_try_count: passwordlessHttpCode.max_try_count,
  blocked: passwordlessHttpCode.blocked,
  otp_message_code_max_retry_for_otp_token: tokenHttpCode.otp_message_code_max_retry_for_otp_token,
  slot_locked: 40945, // eror when return in set appointment/reschedule
  no_free_slots: 40936, // eror when return in set appointment/reschedule

}

const handleTokenHttpCode = {
  customer_too_many_attempts: tokenHttpCode.customer_too_many_attempts,
  otp_token_expired: tokenHttpCode.otp_token_expired,
  otp_message_code_max_retry_for_otp_token: tokenHttpCode.otp_message_code_max_retry_for_otp_token,
  otp_message_code_invalid_for_otp_token: tokenHttpCode.otp_message_code_invalid_for_otp_token,
  otp_no_recipient_address: tokenHttpCode.otp_no_recipient_address
}

export { handleHttpCode, handleTokenHttpCode, rescheduleHttpCode }